export default "__VITE_ASSET__12a98603__"